import React, { Dispatch, SetStateAction } from "react";

type ContextProps = {
  loginUsername: string;
  setLoginUsername: Dispatch<SetStateAction<string>>;
  tempPassword: string;
  setTempPassword: Dispatch<SetStateAction<string>>;
};

export const CredentialsContext = React.createContext<Partial<ContextProps>>({});